import { InputState } from '../../components/input/input.state';

export interface MultiChooserGroupItem {
	color?: string;
	key: string;
	value: string;
}

export interface MultiChooserGroup {
	title: string;
	items: MultiChooserGroupItem[];
	selected: string;
}

export abstract class MultiChooserState extends InputState<string[]> {
	private _groups: MultiChooserGroup[];
	public get groups(): MultiChooserGroup[] {
		return this._groups;
	}
	public set groups(value: MultiChooserGroup[]) {
		this._groups = value;
	}

	constructor(label: string) {
		super(label);
		this.readOnly = true;
	}

	private _displayValue: string;
	public get displayValue(): string {
		return this._displayValue;
	}
	public set displayValue(value: string) {
		this._displayValue = value;
	}

	abstract selectDefaultValue();

	getAllOptions(): MultiChooserGroupItem[][] {
		let allOptions = [];

		//we only keep the last selected node. If intermediate nodes are important, this function needs to be overwritten (see NestedListChooserState)
		for (let group of this.groups) {
			for (let item of group.items) {
				allOptions.push([item]);
			}
		}
		return allOptions;
	}
}
